import axios from '@/libs/api.request'
import config from '@/config'

const workFlowBaseUrl = config.baseWorkflowUrl + '/api/v1/'

export const getModuleReleaseFlow = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'module_release_flow/',
    params: params,
    method: 'get'
  })
}

export const createModuleReleaseFlow = (data) => {
  return axios.request({
    url: workFlowBaseUrl + 'module_release_flow/',
    data: data,
    method: 'post'
  })
}

export const detailModuleReleaseFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'module_release_flow/' + id + '/',
    method: 'get'
  })
}

export const deleteModuleReleaseFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'module_release_flow/' + id + '/',
    method: 'delete'
  })
}
